export enum SurfaceGenericType {
  Hexagonal = 'hexagonal',
  Cylindrical = 'cylindrical',
  WithBasePlate = 'with_base_plate',
}
